module.exports = __webpack_public_path__ + "img/1-low.8ea311f3.jpg";